import { IForumUser } from '@dtos/Comment'
import { Text, XStack } from 'tamagui'
import { CoverImage } from '@components/CoverImage'
import { useTranslation } from 'react-i18next'
import { authorInitials, displayName } from './utils'

interface IAuthorBadgeProps {
  user: IForumUser | null | undefined
  size?: number
  nameColor?: string
}

export function AuthorBadge({
  user,
  size = 32,
  nameColor = '$text-primary',
}: IAuthorBadgeProps) {
  const { t } = useTranslation('Comments')
  const fallback = t('anonymous')
  const name = displayName(user, fallback)
  const initials = authorInitials(user, fallback)

  return (
    <XStack gap="$spacing-inset-xs" alignItems="center">
      {user?.avatarUrl ? (
        <CoverImage
          uri={user.avatarUrl}
          width={size}
          height={size}
          borderRadius={size / 2}
          alt={name}
        />
      ) : (
        <XStack
          width={size}
          height={size}
          borderRadius={size / 2}
          backgroundColor="$bg-accent-soft"
          alignItems="center"
          justifyContent="center"
        >
          <Text
            fontFamily="$mulishBold"
            fontSize="$font-size-xxs"
            color="$accent"
          >
            {initials}
          </Text>
        </XStack>
      )}
      <Text
        fontFamily="$mulishBold"
        fontSize="$font-size-xs"
        color={nameColor}
        fontWeight="bold"
        numberOfLines={1}
      >
        {name}
      </Text>
    </XStack>
  )
}
